import type { PlayCanvasHudSnapshot } from '@viewer/playcanvas/mountPlayCanvasViewer';

export const CLOSED_HUD_LOADING_INTERVAL_MS = 500;

type HudSnapshotGateOptions = {
  debugOpen: boolean;
  nowMs: number;
  lastCommittedMs: number;
};

function sameCanvasSize(a?: { w: number; h: number }, b?: { w: number; h: number }): boolean {
  return a?.w === b?.w && a?.h === b?.h;
}

export function shouldCommitHudSnapshot(
  previous: Partial<PlayCanvasHudSnapshot> | null,
  next: Partial<PlayCanvasHudSnapshot>,
  options: HudSnapshotGateOptions,
): boolean {
  if (!previous) return true;
  if (options.debugOpen) return true;

  if (
    previous.loadState !== next.loadState ||
    previous.worldReady !== next.worldReady ||
    previous.entrancePhase !== next.entrancePhase ||
    previous.streamingPhase !== next.streamingPhase ||
    previous.pointerLocked !== next.pointerLocked ||
    previous.droneMode !== next.droneMode ||
    previous.collisionLoaded !== next.collisionLoaded ||
    previous.graphicsApi !== next.graphicsApi ||
    previous.gsplatRenderer !== next.gsplatRenderer ||
    previous.errorMessage !== next.errorMessage ||
    previous.bootstrapComplete !== next.bootstrapComplete ||
    !sameCanvasSize(previous.canvasSize, next.canvasSize)
  ) {
    return true;
  }

  const loadingOrEntranceActive =
    next.loadState !== 'ready' || next.worldReady !== true || next.entrancePhase !== 'done';
  return (
    loadingOrEntranceActive &&
    options.nowMs - options.lastCommittedMs >= CLOSED_HUD_LOADING_INTERVAL_MS
  );
}
